import { PersonnelApi, TagApi } from '@wiz-api/personnel-position'
import {
  get,
  isEmpty,
  map,
  filter,
  find,
  remove,
  forEach,
  cloneDeep,
  some,
  uniq,
  concat,
} from 'lodash'

// const personnelApi = new PersonnelApi()
const tagApi = new TagApi()
// 读取websocket连接地址
const socketPath =
  get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit"].config')
    ?.PersonnelPositionPath || ''
// 全部人员列表（不管在不在线）
// let personnelList = []
// 当前在线的列表
let onlineTagList = []
// 当前需要更新的实时定位数据
let currentPositionList = []
// 当前已经加载并且显示的人员
let currentVisiblePerson = []
let socketObject = null
// 在当前楼层的tagId的数组
// let filterTagList = []
// 是否在楼层中进行筛选
// let isInFloor = false
// 是否展示
// let isDisplay = false
// 所有创建过的人员
let allDataList = []
// 所有的标签
let carTag = []
// 销毁的标识
let isDestroy = false
let cloudRender
let sceneId = ''
let socketDataHandler = null

// 初始化数据
const initData = () => {
  // personnelList = []
  onlineTagList = []
  currentPositionList = []
  currentVisiblePerson = []
  // filterTagList = []
  // isInFloor = false
  // isDisplay = false
  allDataList = []
  carTag = []
  sceneId = ''
  socketObject = null
  isDestroy = false
  socketDataHandler = null
}

// 连接websocket
const connetSocket = () => {
  const socketUrl = `${socketPath}/Position?modelId=${sceneId}&siteId=3a0743fd-2f61-51c2-3bfd-415e973ef230`
  socketObject = new WebSocket(socketUrl)
  socketObject.onmessage = async ({ data }) => {
    if (data.indexOf('连接成功') === 0) {
      // console.log('连接成功!')
    } else {
      socketDataHandler = new Promise(async (resolve) => {
        const res = JSON.parse(data)
        // 两种情况：res.positionList和res.onLineList只有一个有值
        if (!isEmpty(res) && isEmpty(res.positionList) && !isEmpty(res.onLineList)) {
          // res.onLineList有值的时候onlineTagList筛选出设置了标签的人员
          onlineTagList = filter(res.onLineList, (el) => {
            return find(carTag, ['tagCode', el.tagId])
          })
          // 添加名字字段
          onlineTagList = forEach(onlineTagList, (item) => {
            const personDetail = find(carTag, ['tagCode', item.tagId])
            if (!isEmpty(personDetail)) {
              item.name = personDetail.personnelName
            }
          })
          // 与之前创建完成人员相比，筛选出消失的人员
          const hiddenList = remove(currentVisiblePerson, (el) => {
            return !find(onlineTagList, ['tagId', el])
          })
          // 把消失的人员隐藏
          if (!isEmpty(hiddenList)) {
            cloudRender.PosViewer.setPosViewerVisible(hiddenList, false)
          }
          // 需要创建的人员列表（新进来的人员的isNew为true）
          const createArr = map(
            filter(onlineTagList, (el) => {
              // isNew并且没有创建过
              return (
                el.isNew &&
                !some(allDataList, (it) => {
                  return it === el.tagId
                })
              )
            }),
            (item) => {
              const currentTag = find(carTag, (tag) => {
                return tag.tagCode === item.tagId
              })
              const background = currentTag?.color ? translateColor(currentTag.color) : '#2196f3'
              return {
                id: item.tagId,
                position: [item.x, item.y, item.z],
                markerOption: {
                  background,
                  text: item.name,
                  markPosType: 4,
                  nodeOffset: [0, -5],
                },
              }
            }
          )
          // 重新上线的人员
          const reshowList = map(
            filter(onlineTagList, (el) => {
              // 临时下线了
              return (
                el.isNew &&
                !some(currentVisiblePerson, (it) => {
                  return it === el.tagId
                }) &&
                some(allDataList, (i) => {
                  return i === el.tagId
                })
              )
            }),
            (item) => {
              return item.tagId
            }
          )
          // 临时下线的人员再次上线
          await cloudRender.PosViewer.setPosViewerVisible(reshowList, true)
          currentVisiblePerson = uniq(concat(currentVisiblePerson, reshowList))
          // 批量创建人员
          const createdResult = await cloudRender.PosViewer.createPosViewer(createArr)
          if (createdResult.status && !isEmpty(createdResult.data)) {
            if (isDestroy) {
              await cloudRender.PosViewer.destroyPosviewer(createdResult.data)
            } else {
              currentVisiblePerson = uniq(concat(currentVisiblePerson, createdResult.data))
              // 把所有创建过的人存起来
              allDataList = uniq(concat(allDataList, currentVisiblePerson))
            }
          }
        } else {
          // res.positionList有值的时候修改人员位置
          // 当前需要显示的人员：筛选出已经创建并且绑定了标签的人员
          // 更新楼层中的实时定位数据
          const filterPositionList = filter(res.positionList, (el) => {
            return (
              find(carTag, ['tagCode', el.tagId]) &&
              find(currentVisiblePerson, (item) => {
                return item === el.tagId
              })
            )
          })
          const positionEvent = new CustomEvent('setPositionList', {
            detail: {
              position: filterPositionList,
            },
          })
          window.dispatchEvent(positionEvent)
          // 批量设置位置
          await cloudRender.PosViewer.setPosition(
            map(currentPositionList, (item) => {
              return {
                id: item.tagId,
                position: [item.x, item.y, item.z],
              }
            })
          )
        }
        resolve()
      })
    }
  }
}

// rgba转换为十六进制
const translateColor = (rgbaString) => {
  // 利用正则表达式匹配出RGBA中的R、G、B和A通道的值
  const values = rgbaString.match(/\d+(\.\d+)?/g)
  const r = parseInt(values[0])
  const g = parseInt(values[1])
  const b = parseInt(values[2])
  const a = parseFloat(values[3])

  // 将R、G、B三个颜色通道的值转换为十六进制，并补齐到两位
  const rHex = r.toString(16).padStart(2, '0')
  const gHex = g.toString(16).padStart(2, '0')
  const bHex = b.toString(16).padStart(2, '0')

  // 将A通道的值转换为十六进制，并补齐到两位
  const aHex = Math.round(a * 255)
    .toString(16)
    .padStart(2, '0')

  // 拼接R、G、B、A四个通道的十六进制数值
  const hexColor = `#${rHex}${gHex}${bHex}${aHex}`

  return hexColor
}

// 获取车辆标签
const getCarTag = async () => {
  const [err, res] = await tagApi.getTagList({
    keyword: '',
    type: '',
    departmentId: '',
    maxResultCount: 1000,
    skipCount: 0,
  })
  if (!err && !isEmpty(res)) {
    carTag = res.items.filter((item) => {
      return item.type === 3
    })
  }
}

// 创建车辆
const create = async (player, propSceneId, propCloudRender) => {
  if (!player.Native) {
    return
  }
  // 初始化数据
  initData()
  cloudRender = propCloudRender
  sceneId = propSceneId
  await getCarTag()
  connetSocket()
}
// 销毁车辆
const destroy = async (player) => {
  // 断开websocket连接
  if (socketObject) {
    socketObject.close()
  }
  isDestroy = true
  await socketDataHandler
  if (!player.Native || !cloudRender.PosViewer) {
    return
  }
  await cloudRender.PosViewer.destroyPosviewer(allDataList)
}

const hidden = async () => {
  cloudRender.PosViewer.setPosViewerVisible(currentVisiblePerson, false)
}

const display = async () => {
  cloudRender.PosViewer.setPosViewerVisible(currentVisiblePerson, true)
}
export default {
  create,
  destroy,
  hidden,
  display,
}
